import { usePlaidLink } from "react-plaid-link";

type PlaidMetadata = { accounts?: { id: string }[] };

export function TransporterPlaidLinkButton({
  linkToken,
  onPlaidSuccess,
  label = "Link bank with Plaid",
  disabled,
  className = "btn-primary disabled:cursor-not-allowed disabled:opacity-50",
}: {
  linkToken: string;
  onPlaidSuccess: (publicToken: string, metadata: PlaidMetadata) => void;
  label?: string;
  disabled?: boolean;
  /** Override styles (e.g. onboarding uses green). */
  className?: string;
}) {
  const { open, ready } = usePlaidLink({
    token: linkToken,
    onSuccess: (publicToken, metadata) => {
      onPlaidSuccess(publicToken, metadata);
    },
  });

  return (
    <button
      type="button"
      disabled={disabled || !ready}
      onClick={() => open()}
      className={className}
    >
      {label}
    </button>
  );
}
